import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { css } from '@emotion/react';
import { colors, getResetByTag, baseUnits, utilityStyles, rem } from './../../styles';
var defaultStyles = process.env.NODE_ENV === "production" ? {
  name: "16k2f8p",
  styles: "&>*{list-style:none;}"
} : {
  name: "fv0pfu-defaultStyles",
  styles: "&>*{list-style:none;};label:defaultStyles;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var spaceStyles = function spaceStyles(_ref2) {
  var spacing = _ref2.spacing;
  if (spacing === '') {
    return /*#__PURE__*/css("&>li{padding:", rem("".concat(baseUnits.rootRhythmUnit / 2), 0), ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:spaceStyles;"));
  } else if (spacing === '2') {
    return /*#__PURE__*/css("&>li{padding:", rem("".concat(baseUnits.rootRhythmUnit), 0), ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:spaceStyles;"));
  } else {
    return /*#__PURE__*/css("&>li{padding:", rem("".concat(baseUnits.rootRhythmUnit * (spacing / 2)), 0), ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:spaceStyles;"));
  }
};
var _ref = process.env.NODE_ENV === "production" ? {
  name: "x0saz6",
  styles: "&>li{border:unset;}"
} : {
  name: "1kbny2o-dividerStyles",
  styles: "&>li{border:unset;};label:dividerStyles;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var dividerStyles = function dividerStyles(_ref3) {
  var divider = _ref3.divider;
  switch (divider) {
    case 'top':
      return /*#__PURE__*/css("&>li{border-top:", rem(1), " solid ", colors.coolGray_500, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:dividerStyles;"));
    case 'bottom':
      return /*#__PURE__*/css("&>li{border-bottom:", rem(1), " solid ", colors.coolGray_500, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:dividerStyles;"));
    case 'none':
      return _ref;
    default:
      return /*#__PURE__*/css("&>li:not(:last-of-type){border-bottom:", rem(1), " solid ", colors.coolGray_500, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:dividerStyles;"));
  }
};
var itemPaddingStyles = function itemPaddingStyles(_ref4) {
  var itemPadding = _ref4.itemPadding;
  switch (itemPadding) {
    case 'xs':
      return /*#__PURE__*/css("&>li div{margin:", rem(0, 8, 0, 8), ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:itemPaddingStyles;"));
    case 'sm':
      return /*#__PURE__*/css("&>li div{margin:", rem(0, 12, 0, 12), ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:itemPaddingStyles;"));
    case 'lg':
      return /*#__PURE__*/css("&>li div{margin:", rem(0, 24, 0, 24), ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:itemPaddingStyles;"));
    case 'xl':
      return /*#__PURE__*/css("&>li div{margin:", rem(0, 32, 0, 32), ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:itemPaddingStyles;"));
    case 'gi':
      return /*#__PURE__*/css("&>li div{margin:", rem(0, 40, 0, 40), ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:itemPaddingStyles;"));
  }
};
var resetStyles = getResetByTag('ul');
var StyledVerticalList = /*#__PURE__*/_styled('ul', process.env.NODE_ENV === "production" ? {
  target: "eipjgyv0"
} : {
  target: "eipjgyv0",
  label: "StyledVerticalList"
})(resetStyles, defaultStyles, spaceStyles, dividerStyles, itemPaddingStyles, utilityStyles);
export default StyledVerticalList;